<template>
  <div>
    <!-- <br /> -->
    <!-- <h2 class="rg-title">職歴</h2> -->
    <div class="row">
      <div class="col-md-8">
        <div class="profile-info-block">
          <div class="table-responsive">
            <div>
              <div class="mb-3" v-if="history.lastCompany">
                <div class="d-flex flex-column">
                  <span>
                    <span class="bar-highlight">|</span> 直近在籍企業</span
                  >
                  <div
                    v-html="
                      highlightText(
                        ['recent_registered_company_name'],
                        history.lastCompany
                      )
                    "
                  ></div>
                  <div v-if="history.currently_enrolled === false">
                    {{
                      `${enrollment_period.from.year}年${enrollment_period.from.month}月 ~ ${enrollment_period.to.year}年${enrollment_period.to.month}月`
                    }}
                    (離職中)
                  </div>
                  <div v-else>
                    {{
                      `${enrollment_period.from.year}年${enrollment_period.from.month}月 ~ `
                    }}
                    (在職中)
                  </div>
                  <span>{{ history.status.title }}</span>
                </div>
              </div>

              <div class="mb-3">
                <div class="d-flex flex-column">
                  <span>
                    <span class="bar-highlight">|</span>
                    直近職種
                  </span>
                  <span>{{ lastJob }}</span>
                  <span>{{ history.lastYearIncome }} 万円</span>
                  <span v-if="history.position">{{
                    history.position.title
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="profile-info-block">
          <div class="mb-3">
            <div class="d-flex flex-column">
              <span> <span class="bar-highlight">|</span> 経験社数</span>
              <div>{{ history.experienceCompanies }}社</div>
            </div>
          </div>

          <div class="mb-3" v-if="history.englishSkill">
            <div class="d-flex flex-column">
              <span> <span class="bar-highlight">|</span> 英語力</span>
              <div>{{ history.englishSkill.title }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Scrollable section starts here -->
      <!-- <div class="col-md-12"> -->
        <div class="col-md-12">
          <div class="profile-info-block">
            <div class="table-responsive">
              <table class="table">
                <tbody>
                  <tr>
                    <th class="resumeth">
                      <span class="bar-highlight">|</span> 職務経歴書
                    </th>
                    <td
                      class="resumetd"
                      style="white-space: pre-wrap !important"
                      v-if="history.resume"
                    >
                      <a
                        @click="onLinkClick('resume')"
                        :class="[
                          resumeLoading ? 'disabled' : ' ',
                          'preview-resume',
                        ]"
                        >{{ history.resume }}</a
                      >
                    </td>
                  </tr>
                  <tr>
                    <th class="resumeth">
                      <span class="bar-highlight">|</span> 履歴書
                    </th>
                    <td
                      class="resumetd"
                      style="white-space: pre-wrap !important"
                      v-if="history.cv"
                    >
                      <a
                        @click="onLinkClick('cv')"
                        :class="[
                          resumeLoading ? 'disabled' : ' ',
                          'preview-resume',
                        ]"
                        >{{ history.cv }}</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- ends profile-info-block -->
          
          <div class="profile-info-block">
            <div class="mb-3">
              <div class="d-flex flex-column">
                <span class="mb-1">
                  <span class="bar-highlight">|</span> 職務要約</span
                >
                <div
                  class="whitespace-pre-wrap"
                  v-html="highlightText(['job_summary'], history.summary)"
                ></div>
              </div>
            </div>
          </div>
          <!-- ends profile-info-block -->
          
          <div class="profile-info-block">
            <div class="mb-3">
              <div class="d-flex flex-column">
                <span class="mb-1">
                  <span class="bar-highlight">|</span> 職務経歴書情報
                </span>
                <div
                  class="whitespace-pre-wrap"
                  v-html="highlightText(['resumeContent'], history.resumeContent)"
                ></div>
              </div>
            </div>
          </div>
          
          <div class="profile-info-block">
            <div class="mb-3">
              <div class="d-flex flex-column">
                <span class="mb-1">
                  <span class="bar-highlight">|</span> 配慮事項</span
                >
                <div class="word-break">
                  {{ history.career_change_reason }}
                </div>
              </div>
            </div>
          </div>
          <!-- ends profile-info-block -->
        </div>
      <!-- </div> -->
      <!-- End scrollable section -->
    </div>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: 'EmploymentInfo',
  props: {
    history: {
      required: true,
    },
    resumeLoading: {
      required: true,
    },
    eventHistory: {
      required: true,
    },
    applicant: {
      required: true,
    },
    highlights: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onLinkClick(type) {
      this.$emit('previewClick', type);
    },
    formatDate(date) {
      return moment(date)
        .utc()
        .format('YYYY-MM-DD');
    },
    highlightText(paths, originalText) {
      if (!this.highlights || !this.highlights.length) {
        return originalText;
      }

      const highlights = this.highlights.filter((h) => paths.includes(h.path));
      if (highlights.length === 0) {
        return originalText;
      }

      let highlightedText = originalText;

      for (let highlight of highlights) {
        // Sort hit texts by length (longest first) to handle overlapping matches
        const hitTexts = highlight.texts
          .filter((t) => t.type === 'hit')
          .sort((a, b) => b.value.length - a.value.length);

        // Process each hit text separately
        for (let hitText of hitTexts) {
          const searchRegex = new RegExp(
            this.escapeRegExp(hitText.value),
            'gi'
          );
          highlightedText = highlightedText.replace(
            searchRegex,
            (match) => `<mark>${match}</mark>`
          );
        }
      }
      return highlightedText;
    },
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
  },
  computed: {
    joinedDate() {
      return moment(this.applicant.joinedDate)
        .utcOffset('+0900')
        .format('YYYY-MM-DD');
    },
    lastJob() {
      const { lastJob } = this.history;
      const { child } = lastJob;
      return `${lastJob.title} / ${child.title}`;
    },
    enrollment_period() {
      let enrolled = false;
      if (
        this.history.currently_enrolled === false &&
        typeof this.history.enrollment_period === typeof {}
      ) {
        let fromDate = new Date(this.history.enrollment_period.from);
        let toDate = new Date(this.history.enrollment_period.to);
        enrolled = { from: {}, to: {} };
        enrolled.from.year = String(fromDate.getUTCFullYear());
        enrolled.from.month = ('00' + (fromDate.getUTCMonth() + 1)).slice(-2);
        enrolled.to.year = String(toDate.getUTCFullYear());
        enrolled.to.month = ('00' + (toDate.getUTCMonth() + 1)).slice(-2);
      } else if (
        this.history.currently_enrolled === true &&
        this.history.enrollment_period &&
        this.history.enrollment_period.from
      ) {
        let fromDate = new Date(this.history.enrollment_period.from);
        enrolled = { from: {}, to: {} };
        enrolled.from.year = String(fromDate.getUTCFullYear());
        enrolled.from.month = ('00' + (fromDate.getUTCMonth() + 1)).slice(-2);
        enrolled.to.year = '';
        enrolled.to.month = '';
      }
      return enrolled;
    },
    yearsAttended() {
      if (
        this.history.currently_enrolled === false &&
        typeof this.history.enrollment_period === typeof {}
      ) {
        let fromDate = new Date(this.history.enrollment_period.from);
        let toDate = new Date(this.history.enrollment_period.to);
        let diffMS = toDate.getTime() - fromDate.getTime();
        let yearInMS = 1000 * 3600 * 24 * 364;
        return Math.floor(diffMS / yearInMS);
      } else if (
        this.history.currently_enrolled === true &&
        this.history.enrollment_period &&
        this.history.enrollment_period.from
      ) {
        let fromDate = new Date(this.history.enrollment_period.from);
        let toDate = new Date();
        let diffMS = toDate.getTime() - fromDate.getTime();
        let yearInMS = 1000 * 3600 * 24 * 364;
        return Math.floor(diffMS / yearInMS);
      } else {
        return this.history.yearsAttended || 0;
      }
    },
    currently_enrolled() {
      if (
        this.history.currently_enrolled !== undefined &&
        this.history.currently_enrolled !== null
      ) {
        return this.history.currently_enrolled ? '在籍中' : '離職中';
      } else {
        //prev value
        return this.history.employmentSituation || false;
      }
    },
    events() {
      return this.eventHistory;
    },
  },
  mounted() {
    this.$emit('employmentLoaded');
  },
};
</script>

<style scoped>
/deep/ mark {
  background-color: yellow !important;
}
.word-break {
  word-break: break-word !important;
}
.whitespace-pre-wrap {
  white-space: pre-wrap !important;
}
.bar-highlight {
  display: inline-block;
  width: 4px; /* wider bar */
  background-color: #3c3c3c; /* solid black */
}

.resumetd {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.resumetd a {
  white-space: pre;
}
.hitstoryth,
.resumeth {
  width: 15%;
}
.event {
  border: none !important;
  font-size: 12px;
  white-space: normal !important;
  word-break: break-word;
  min-width: 80px;
  color: #617776;
  padding: 5px 7px !important;
}
#eventLabel {
  color: #036d6c;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}
.preview-resume {
  font-size: 16px;
  color: #007bff;
  cursor: pointer;
}
.preview-resume.disabled {
  pointer-events: none;
}
.preview-resume:hover {
  text-decoration: underline;
}

</style>
